module.exports = __webpack_public_path__ + "img/pengiriman.c63fd43c.jpg";